var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetStarted3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1086.24 948.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#888989;}.cls-2{fill:#140f0f;}.cls-3{fill:#301f23;}.cls-4{fill:#130d0f;}.cls-5{fill:#d88d5b;}.cls-6{fill:#1a6f83;}.cls-7{fill:#2092a5;}.cls-8{fill:#bbcae0;}.cls-9{fill:#145b66;}.cls-10{fill:#5d7c89;}.cls-11{fill:#f7b17a;}.cls-12{fill:#e6814f;}.cls-13{fill:#255667;}.cls-14,.cls-51{fill:#137e7b;}.cls-15{fill:#e15d10;}.cls-16{fill:#e59e06;}.cls-17{fill:#69999e;}.cls-18{fill:#fff;}.cls-19{fill:#bb572f;}.cls-20{fill:#1f1815;}.cls-21{fill:#2e221e;}.cls-22{fill:#1b8c87;}.cls-23{fill:#f9de52;}.cls-24{fill:#626161;}.cls-25{fill:#cee9ef;}.cls-26{fill:#f5dfd4;}.cls-27{fill:#90c1ca;}.cls-28,.cls-47{fill:#44b8af;}.cls-29{fill:#3fa094;}.cls-30{fill:#e73332;}.cls-31{fill:#e52624;}.cls-32{fill:#3e1513;}.cls-33{fill:#1f1317;}.cls-34{fill:#304c20;}.cls-35{fill:#e7e1dd;}.cls-36{fill:url(#linear-gradient);}.cls-37{fill:#6caa43;}.cls-38{fill:#fffbf9;}.cls-39{fill:#3b3348;}.cls-40{fill:#26100f;}.cls-41{fill:#096b99;}.cls-42{fill:#0c4c64;}.cls-43{fill:#0f8bb7;}.cls-44{fill:#0d5f7d;}.cls-45{fill:#3f1617;}.cls-46{fill:#140a0a;}.cls-47{opacity:0.71;}.cls-48{opacity:0.4;}.cls-49{fill:#73c4be;}.cls-50{fill:#394150;}.cls-51{opacity:0.96;}.cls-52{fill:none;stroke:#137e7b;stroke-miterlimit:10;stroke-width:5.78px;}.cls-53{fill:#3b3a3a;}.cls-54{fill:#bababa;}.cls-55{fill:#e2e1e1;}.cls-56{fill:#f5a46c;}.cls-57{fill:#0e0e10;}.cls-58{fill:#18191f;}.cls-59{fill:#313944;}.cls-60{fill:#84bac2;}.cls-61{fill:#f8f9fd;}.cls-62{fill:#3e2827;}.cls-63{fill:#d86f41;}.cls-64{fill:#161110;}.cls-65{fill:#74514b;}.cls-66{fill:#694844;}.cls-67{fill:#0d3935;}.cls-68{fill:#2e2b2a;}.cls-69{fill:#0c443d;}.cls-70{fill:#737373;}.cls-71{fill:#e2271d;}.cls-72{fill:#0f5a76;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 265.93,
    y1: 527.18,
    x2: 367.08,
    y2: 527.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#50bcc0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1085.63,938.3c30.65,13.38-1115.73,13.38-1085,0C-30,924.92,1116.35,924.92,1085.63,938.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M913,163c16.08,2.79,36.41,1.83,51.11,11.44,36.11,47,29.75,119.29,42.71,175.92,55.07,156.86-195.74,175.25-173.51,16.15C829.34,372.83,913.81,162.08,913,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M703.18,936.89c55.33,4.14,81.27,17.73,55.68-51.45l-18.25,2.32C729.3,916,698.17,918.69,703.18,936.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M768,936.61c-13.73,2.15-71.29,11-64.62-7.55C704.63,939.71,779.28,923.44,768,936.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M767.33,835.29,737.64,821c5.88,25.92-13.6,93.08,13.77,83.13C759.17,899.93,768.62,848.35,767.33,835.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.11,879.44c-22.14-1.06-2.75,25.08-9.35,33.46l18.73.56C751.91,903.74,758.61,878.52,739.11,879.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M946.24,937.5c-61.58,7.24-69.42,6.49-49.19-52.07l18.25,2.33C921.77,911.08,949.1,915.56,946.24,937.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M946.24,937.5c-11.93,2.37-62.47,7.51-59.37-8C897.84,935.4,951,924.57,946.24,937.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M888.58,835.29,918.27,821c-5.88,25.92,13.6,93.08-13.77,83.13C896.74,899.93,887.28,848.35,888.58,835.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M916.8,879.44c22.14-1.06,2.75,25.08,9.34,33.46l-18.72.56C904,903.74,897.29,878.52,916.8,879.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M937.6,474c-9.06,99.22-2.88,295.73-14.46,396.08L888,871.35c-18.7-111.85-11.41-260.25-29.67-380.6.09-3.43,2.16-64.87,2.17-65.92C925.27,429.19,946.92,391.21,937.6,474Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M728.78,867.49l33.5,2.55c14.63-38,31.51-85.79,38.15-135.64,11.25-97.24,56.59-196.28,67.65-295.32,2.58-7.73-2.06-6-7.84-6.73-50.35,2-74.86-32.08-76.19,35.21C776.18,573,743.59,748.41,728.78,867.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883,855.58c-6.39,26.58,26.68,16.17,41.34,18.81C937.51,843.88,900.34,859.25,883,855.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M816,428.48c3.24,16.76-17.8,54.88-32,39.09C815.59,469.38,804.66,434.85,816,428.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M730.64,858.23c60.48,12.14,55.12-72.92,69.79-123.83,9-80.29,42.47-163.37,59.48-244-26.81-6.84-23.67,31.37-29.19,49.93-11.63,52.8-37.48,103.3-41.64,157.84C784.33,835,731.42,759.9,730.64,858.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M937.6,474C922.32,489.32,897.91,454.4,901,436.7c-1.2-2.45,2.2-1.79,3.53-2.12C904.57,453.78,914.59,476.46,937.6,474Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M845.43,494.79c-3.81-9.18-2.31-54.06,8.26-51.78-2.72,9.7-17.86,56,6.48,47.61C862.32,497.47,852.85,493.53,845.43,494.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M869.68,439.44c-8.17,20.6-8.23,114.88-11.29,60.53-.07.44-.64,4.28-.79,4.61C860.91,487.22,856.79,447.36,869.68,439.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M729.59,850.81c-13.32,27,23.9,15.75,37.49,19.94C782.73,841.34,747.12,854.51,729.59,850.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M961.67,264.46c-15.62,70.64-20.64,114-18.91,176.18-5.34,16.45-121.43,10.75-155.46-5.12,13.31-68.66,13.32-140.19-11.52-201.09-1.06-10.83,8.1-52.44,9.83-63.67,1.66-10.69,36.37-9.89,43.63-18.17,12,7.61,28,9.54,42.08,8.17,26.37-14.2,63.69-12.65,91.49-2.08C979.36,176.27,963.11,241.44,961.67,264.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M822.38,156.6c11.44,47.92,67.33,32,87.72-6.94-13.22,2-17.91-9.95-18.9-21.63-1.66-11.84,0-25.94-.62-37.57-12.64,6.35-48.37,23.85-60.48,29.92C831.18,133.12,838,149.54,822.38,156.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M830.1,120.38c0,59.65,59.49,19.31,60.37-9.12h-42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M961.67,264.46c-15.62,70.65-20.64,114-18.91,176.18-.41,17.05-123,11.35-155.69-5.65,9.22-50.39,14.8-117.14,1.51-161.12,121.63,51.23,167-1.31,178.64-109.77C974.05,183,964.72,243.76,961.67,264.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M949.34,250.72c29.63,42.47,30,74.16,56.1,111.83,20,8.84,35.79-12.31,33.26-34.24C1025.22,264.66,968.09,73.48,932.05,221,932.2,229.61,949.34,250.72,949.34,250.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M869.66,500.87c30.94,7.15,67.55-8.26,98.77,0,.43-5.47-10.86-167.36-9.53-182-5.65-41.52,54.09-168.43-25.37-167.56-15.61.46-34.07-11.43-33,2.88C896.5,215.56,872.22,483.12,869.66,500.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M832.21,503.55c-25.66,5.8-54.76-10.86-80.64-3.95,13.59-21.51-8.48-376.58,72.2-345.11C823.6,217.15,831,482.58,832.21,503.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M715.3,494.82c-14.18,1.12,7.52-78.6,5.34-84.14-4.55-14.75,116.52,13,120.24,10.51,14.17-1.11-7.52,78.61-5.34,84.15C840.09,520.08,719,492.37,715.3,494.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M716.09,489.29c-14.17,1.12,7.52-78.6,5.34-84.13-4.55-14.75,116.52,13,120.24,10.51,14.17-1.11-7.52,78.61-5.34,84.14C840.88,514.56,719.81,486.85,716.09,489.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M827.39,421.23c-3.25-.41-2.52-5.52.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M815.07,419.47c-3.26-.42-2.52-5.53.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M802.74,417.7c-3.25-.42-2.52-5.52.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M790.42,415.93c-3.26-.42-2.52-5.52.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M778.09,414.16c-3.25-.42-2.52-5.52.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M765.77,412.39c-3.26-.42-2.52-5.52.72-5s2.52,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M753.44,410.62c-3.25-.42-2.52-5.52.72-5s2.53,5.52-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M741.12,408.85c-3.25-.42-2.52-5.52.72-5s2.52,5.53-.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M827.74,418.84c-2.5-.37-.67-13.11,1.83-12.76s.67,13.1-1.83,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M815.41,417.07c-2.49-.36-.67-13.11,1.83-12.76s.68,13.1-1.83,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M803.09,415.3c-2.5-.36-.68-13.11,1.83-12.76s.67,13.1-1.83,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M790.76,413.53c-2.49-.36-.67-13.1,1.83-12.76s.68,13.1-1.83,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M778.44,411.76c-2.5-.36-.67-13.1,1.83-12.76s.67,13.1-1.83,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M766.11,410c-2.49-.37-.67-13.11,1.83-12.77s.68,13.1-1.83,12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M753.79,408.23c-2.5-.37-.67-13.11,1.83-12.77s.67,13.1-1.83,12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M741.46,406.46c-2.49-.37-.67-13.11,1.83-12.77s.68,13.1-1.83,12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M947.66,241.34l.25.7A2.2,2.2,0,0,1,947.66,241.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M810,28.67c30.28,10.71-.35,26.55,8.24,56.38C807.78,70.44,803.55,45.86,810,28.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.7,82.29c10.62,73.68-103.66,111-77-55.48C868.5,2,906.6,25.08,895.7,82.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M809.27,71.28c11.3,2.62,8.51,21.27,9.2,29.62C806.32,114.36,793.61,71.43,809.27,71.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M813.69,83c-4.76,1.7-3.11,8.83.62,10.5.26-.25-5.08.55-6.17-3.21-2-4.2,5.72-16.68-3-11.14C806.92,70.3,813.91,76.36,813.69,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866,82c.66.4,1.46-2.12,2.11-1.81,6,3.89,13.49-.25,17.2,2.43C882,71.57,868.54,70.56,866,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M866,82c5.88,4.18,15.3,3.4,19.31.62C880.78,75,870.45,74.79,866,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M867.92,81.62c3.84,6,16.73,4.57,12.08-4.06C876.38,76.16,867.53,76.25,867.92,81.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M871,81c0,2.08,1.63,2.08,1.62,0S871,78.91,871,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820,82.56c.65.36,1.27-2.22,1.91-2,5.91,3.46,12.83-1.2,16.49,1.21C834.64,70.94,821.66,71.21,820,82.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M820,82.56c5.83,3.78,14.82,2.28,18.4-.74C833.7,74.49,823.72,75.21,820,82.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M821.82,82.08c4.09,5.82,16.2,3.17,11.28-4.89C829.45,76,821.1,76.87,821.82,82.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M824.79,81.07c.11,2.08,1.68,1.94,1.54-.12S824.66,79,824.79,81.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M829.55,68.75C834,69.08,843.86,70.14,840,76c-5.52,1.5-17.8-2.87-23.82-.89C820.05,69.07,822.2,67.3,829.55,68.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M874.36,68c-4.49.38-15.86.66-11.63,7.08,6.11,1.61,19.76-2.54,26.46-.44C884.9,68.53,882.52,66.72,874.36,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M865.58,113.94c-7.74,4.2-17.23,6.42-25.71,3.18C847.05,124.05,859.81,121.47,865.58,113.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845,86.57c-3.14,13,1.79,21.59,12.25,18.39C840.67,115.23,838.8,103,845,86.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M856.53,86.57c-.36-15,33.05-15,32.69,0C889.58,101.63,856.17,101.63,856.53,86.57Zm2.05,0c-.32,12.25,28.92,12.25,28.59,0C887.49,74.33,858.25,74.33,858.58,86.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M812.47,86.29c-.33-15.06,32.22-15.06,31.88,0C844.69,101.34,812.13,101.34,812.47,86.29Zm2,0c-.3,12.24,28.09,12.24,27.78,0C842.6,74,814.22,74,814.52,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M856.72,85.34c5.91-6.25-17.64-7.17-13.3-.38C847.38,81.6,853.64,80.81,856.72,85.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M816.8,40.8C839.91,59.28,891.13,30,896.08,59.42c.48,5-5,37,3.9,33.36C978.86-28.3,757.67-14.15,816.8,40.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M816.8,40.8C839.93,59.28,891.13,30,896.08,59.42c-7.23,57,15.15,29.74,20.8-23.82-8.11-32.53-8.52-6.84-25.21-.35-12.57-2.38-24.72,1.12-37.25,2.94-17,1.39-37-6.07-48.61-19C802.28,26.41,811.48,37.24,816.8,40.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M909,76.54c-12.73.69-13.32,21.27-16.77,30C904.31,123.32,928,79.85,909,76.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M901.44,88.28c5.43,2.76,2.07,10.09-2.76,11.15,16.5,4.86,2.08-23.33,13.82-13.6C912.05,76,902.43,81.08,901.44,88.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886.66,225.45c-1.18,72.24,35.1,142.16,96.5,180.11-2.64-4.69-9.65-22.53-14.8-24.82-45.36-38.64-64.06-101.83-59-160.19v0c2.44-24,9.44-50.24,23.84-68.84C886.42,132.21,890.26,193,886.66,225.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M955.56,310.3c-4.44,1.23-46.95-29.8-51.67-30.31-5.61-.58-31.9-8.61-22.27-18.95-6.18-4.07-5.88-12.68.4-14.35-6.22-5.12-4.29-8.56,1.91-12.32-8.74-11.61,2-10.23,11.28-8.66,12.74,2.23,14.18,2.66,10.68-11.63,5.91-32.15,32.06,48,33.4,53.18C932.75,270.58,962.58,308.34,955.56,310.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888.61,275c-6.92-3.46-12.26-8.41-7-13.94-6.18-4.07-5.88-12.68.4-14.35-6.22-5.12-4.29-8.56,1.91-12.32-8.74-11.61,2-10.23,11.28-8.66,1.28,2.77-1.4,6.48-4.76,8.3a7.81,7.81,0,0,1-1.69,13.65c3.32,2.55,3.23,7.86-.8,9.72C893.1,261.87,892.4,270.23,888.61,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M929.57,301.2c-7.8,8.3,110.9,116.59,109.14,27.11-16.76-20.83-89.35-48.82-99.4-64.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M749.11,449.35l28.77,1.18c2.36,16,55.88,37.79,28.48,39.64-23.84-17-2.09,32.85-21.77,16-4.4,4.86-7.78,6-11.26-.42-2.56,5.29-10.25,4.08-12.8-2.1C735.68,503.12,756,469.33,749.11,449.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M749.36,495.05c1.88,6.73,5.37,12.31,11.17,8.59,2.55,6.18,10.24,7.39,12.8,2.1,3.48,6.41,6.86,5.28,11.26.42,8.8,9.75,9.41,0,9.62-8.52-2.24-1.61-6,.13-8.19,2.8a7.05,7.05,0,0,0-12.39-.84c-1.7-3.38-6.42-4.22-8.76-1C761.76,493.31,754.23,492.49,749.36,495.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M749.27,457c48.69-3.62,23.55-6.38,33.59-61.73-.83-29.74,14.3-63-5.57-77.52C702.3,296,743.77,455.19,749.27,457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M758.75,206.29c5.94-19.75,10.24-40.42,32.41-46.09-2.73,29.52,10.56,159.52-10.38,183.27C695.47,455.21,750.69,230.43,758.75,206.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M975.36,282.53c-6.92-11.7-17.39-38.43-19.06-50.25,11.78,28.61,23.25,44.66,27.73,59.78C944.7,280.2,925.73,250.92,975.36,282.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M772.62,437.62c13.06,67.39,7.65-172.81,16.94-198.54C771.66,293.21,773.19,397.19,772.62,437.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M321.77,938.64c67.2,5,38-1.8,17.56-45.22-.41.09-13.75-2.39-14-1.94C323.81,896.34,313.42,931.77,321.77,938.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M354.7,813.1c-4.27,21.72-13.65,62.49-13.65,85.12,0,7.62-2.39,17.94-12.34,4.84-6.49-8.53-7.26-62.86-7.4-75.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.35,891.23c2.5,47.36,1.28,21.71,29.56,28.3-4.78-3.91-10.14-11.78-16-26.18C334.48,896.21,327,897.49,325.35,891.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M410.54,937.66c67.21,5.32,38-1.62,17.75-45.13-.42.1-13.75-2.46-14-2C412.75,895.37,402.22,930.75,410.54,937.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M442.42,813.75c-4.36,21.7-12.25,63.14-12.35,85.77,0,7.61-2.55,15.75-12.44,2.6-6.46-8.56-7-62.9-7.09-75.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.31,890.27c2.31,47.36,1.2,21.72,29.44,28.45-4.75-3.93-10.08-11.83-15.86-26.25C423.42,895.3,415.93,896.54,414.31,890.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.5,267.2c1.88-44.45-1.14-160.33,43.75-162.89,23.45,14.25,59.95,31.46,51.55,65.86,0,13.82,12.37,2.28,11.27,16-.91,11.49,2.5,86,7.37,88.38C442.22,278.2,336.36,286.9,333.5,267.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M320.94,282.8c2.4-73.25,67.19,6.8,49.8-106.62,52.89,28.55,40.66,4.68,43.26,50.49,1.63,16.6,18.82,18.44,33.24,26.16C481.06,312.11,350.73,300.87,320.94,282.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M412.61,219.77c4.65,26.69-36.46,12.61-40.55-12.78,2.44-8.83,2.68-23.19-1.32-30.81l40.19,19.17C419,200.46,410.41,211.37,412.61,219.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M260.48,329.66c20,125.43-12.61,157.6,122.91,132.36-9.35-12.49-3-234.34-42.33-219.44C283.85,240.21,256.71,269.6,260.48,329.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M260.48,329.66c9.19,39.84,6,145.07,38.43,141.17,17.76-4.51,70.49,5.2,58.64-22.77-69.58-34.31-48.92-111.27-60-174.17C279.77,221.83,256,299.58,260.48,329.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M447.81,543.19c.72-6.3-1.36-13.68-2.92-19.84-12.09,1.74,1.59-19.44-1.82-20.85l11-4.55c10.21,16.27,12.95,40.83,1.3,56.6C442.3,558.37,427.62,537.81,447.81,543.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M424.09,251.47c50.88-27.73,28.19,120.06,29.63,146.78C467.88,695,395.74,307,424.09,251.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M314.87,294.06C342.65,464.21,258,458.12,434.44,451.75c-9.56-22.25-3.31-85.31,8-109,12.26-20.28,19.6-80.59,8.42-91.11l-30.32-12.13c-6.76,35-42.44,19.15-55,1.16-2.29-2.1-24.65,1.44-50.55,13.52C312.11,255.51,306.21,262.87,314.87,294.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M427,349.68c46.69,2.92,15.82-49.31,15.22-74C441.5,279.24,427.33,348.06,427,349.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M443.62,269l-1.39,6.76C442,272.18,442.39,269.7,443.62,269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M316.32,418.41C494,431.83,393.08,412.53,453,336.74,349.65,388.57,305.8,261.77,316.32,418.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M441.51,239.38c46.05,14.43-12.8,192.22-7.36,117.94,9.1-33.42,18.51-66.3,11.15-99-5.63-14.61-24.73-15.55-27.16-20.53C414.66,226.86,437.67,236.54,441.51,239.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M268.27,828.69C451.7,846.11,517.06,891,468.05,648.25c-13.81-109-32.14-227.18-36.68-245.82,0,0-18.62,8.51-40.29,9.1-20.86.49-53.09-1.75-71-3.1C276.75,519.33,267,766.87,268.27,828.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M314.17,412.56c62.44,3.51,75-213.5-9.89-164.35,4.94,19,21.17-1.42,31.17,5.52,27.56,31.12,18.15,115.61-7.05,142-5.91,4.76-12.75,6.17-20.93,4.31C305.3,407.39,303.35,414.4,314.17,412.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M268.27,828.69c58.92,13.87,150.57,18.16,215.88-.26-5.24-6.3,6.29-155.31-25.62-173C349,706,336.2,538.38,328.76,466.49,314.84,242.19,252.12,854.92,268.27,828.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M449,182.48c-4.32-25.73-21.29,7.36-16.41,10.2C437.1,206.27,449.73,191.57,449,182.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M439.69,178.65c-6.11,7-2.78,17.68,2.69,7-1.43-4.21,1.51-9.65,4.19-3.5C447.19,177.07,441.84,174.74,439.69,178.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M423.62,118.56c-46.22-34.78-76.89,27.71-61.6,74.8,14.65,32.91,56.05,50.27,73.35,2.47C442.87,174.66,445.18,138.23,423.62,118.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.68,162.77c2.37-8.85,31.45,2.8,9.29-.7C421.29,162.53,414.17,165,414.68,162.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.45,164.65c.53-5.26-13.64-7.85-15.93-2.83C381.5,158,389.47,166.92,392.45,164.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M408.73,205.62a11.93,11.93,0,0,1-10.27-.07C396.15,212.68,412.8,210.36,408.73,205.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M407.38,204.85c-2.63,1-8.87.74-11-.1a10.42,10.42,0,0,0,15.22.06C409.4,205.81,408.25,204.87,407.38,204.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M400.19,193.88c3,.48,7,2,9.54-.53C408.94,197.85,402.28,196.81,400.19,193.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M429.62,172.17c-3.77-1.2-12.29,0-15,3.78C410.07,180.64,441.11,173.63,429.62,172.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M433,174.14c-6.6,2.53-11.75,4.9-19,4.1C417.25,172.38,427.78,171.79,433,174.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M428.06,176c-2.73.81-12.32,5.29-11.67-.42C418.57,173.21,434.05,170.22,428.06,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M426.39,175c.06,1-1.54,1.52-1.57.31C424.76,174.31,426.35,173.75,426.39,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M388.25,175c-2.28-2.15-9.9-4.31-13.33-3.11C362.15,174.45,398.81,181.14,388.25,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M390.55,178.1c-7.06-.26-12.73-.09-19.05-3.65C376.78,170.33,386.71,173.91,390.55,178.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M385.3,177.9c-2.82-.32-13.4,0-10.57-5C377.67,171.6,393.09,174.93,385.3,177.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M384.18,176.28c-.32.9-2,.8-1.56-.33C382.94,175,384.62,175.15,384.18,176.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M348.17,183.23c5.33-31.46,34.1,21.55,8.63,14C352.82,195.24,348.59,188.69,348.17,183.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M358.11,178.72c7.22,6.83,3.89,17.36-2.52,7.2,1.33-4.56-2.34-9.4-4.76-3.19C349.86,177.69,355.55,175,358.11,178.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M395,120.42c23.46-46.86,77.66,8.78,42.93,64.47C446.71,92.41,398.05,164.06,395,120.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.66,188.36c2.5-65.83,32.8-21.77,57-60.09C435.16,89.85,366.68,93,356,113.56,339.87,135.16,357,165.26,361.66,188.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M361.66,188.36c2.49-65.81,32.8-21.77,57-60.09,0,0-1.95-6.19-1.95-6.19-7.43,22-38.3-.73-49.3,19.88,2.38-17.6-2.87-11.53-6.68,1.74-6-7.64-6.36-20.94-4.66-30.14C339.88,135.16,357,165.26,361.66,188.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M411.36,177.55c-.25-17.91,27.87-17.91,27.62,0C439.23,195.46,411.11,195.46,411.36,177.55Zm2.09,0c-.21,15.2,23.65,15.2,23.44,0C437.1,162.35,413.24,162.35,413.45,177.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M372.23,177.34c-.25-17.91,27.87-17.91,27.62,0C400.1,195.25,372,195.25,372.23,177.34Zm2.09,0c-.21,15.2,23.65,15.2,23.44,0C398,162.14,374.11,162.14,374.32,177.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M399.48,177.7c3.12-5,8.16-4.57,12.18-.46C416.34,170,393.41,171.19,399.48,177.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M318.32,565.77c8.42,4.25,24.43,6.32,7.49,13.12C312.59,586.3,317.72,572.78,318.32,565.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M375.94,485.42,274.16,466.05l-.31,43.29C283,504.26,385.27,509.78,375.94,485.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M276.65,468.21l97.55,17.33c2.43.3-5.56,10.67-5.42,11.36C366.87,493,264.52,481,276.65,468.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M361.27,485.42c-114.16-20.24-93.53-36.06-94.4,79.13C385,589.4,370.06,609.47,361.27,485.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M361.27,485.42c4,4.19,10.49,1.54,14.67,0-3.59,4.85,8.72,107.46-8,101.34-4.44,0-8-2.35-8-5.25C361,581.25,357.7,482.84,361.27,485.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M362,486c2.84,4.17-6.85,103.13,6.28,98.65,13.08,4.91,3.5-95.5,6.29-99.22C371.64,488.32,365.14,488.42,362,486Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M303.8,486.12v74.09c-.47-.88-20.09-3.13-18.2-5.58v-72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M290.84,538.08c.46-16.47,9.05-7.06,18.86-4.38,4.84,8.87,19.06,26.28,14.9,36.61-5.8,2.23-5.76-10.12-7.85-12.1.36,3.32,3,21.19,2.12,22C284.59,583.39,287.68,571.43,290.84,538.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.75,461.82c27.85-2.51,0,73.7,7.8,83.86-4.82.43-12.6-.21-20.07-.35C297,545.53,278.73,443.25,303.75,461.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M312.94,257.3c37.52-19.7,27.21,65.64,17.44,93.55-5.58,34.91-18.32,157.23-18.94,169.55C267.79,528.29,297.62,274.88,312.94,257.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M696.1,354.23C595.27,392,668.67,254.85,666.57,214.94,709.87,237.3,688,315.27,696.1,354.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M489.24,530.83c4.13-106.64,28-258.67,101.79-346.33C537.72,162.26,448.18,526.3,489.24,530.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M709.72,937.21c-55.33,4.13-81.27,17.73-55.68-51.46l18.25,2.32C683.61,916.35,714.73,919,709.72,937.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M644.91,936.93c13.73,2.15,71.29,11,64.62-7.56C708.28,940,633.62,923.75,644.91,936.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M645.57,835.6l29.7-14.3c-5.89,25.93,13.59,93.09-13.78,83.14C653.73,900.24,644.28,848.67,645.57,835.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M673.79,879.76c22.14-1.07,2.76,25.08,9.35,33.46l-18.72.56C661,904.05,654.29,878.84,673.79,879.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M498.79,937.21c55.33,4.13,81.27,17.73,55.68-51.46l-18.25,2.32C524.91,916.35,493.78,919,498.79,937.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M563.6,936.93c-13.73,2.15-71.29,11-64.62-7.56C500.24,940,574.9,923.75,563.6,936.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.94,835.6l-29.69-14.3c5.88,25.93-13.6,93.09,13.77,83.14C554.78,900.24,564.23,848.67,562.94,835.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M534.72,879.76c-22.14-1.07-2.75,25.08-9.35,33.46l18.73.56C547.52,904.05,554.22,878.84,534.72,879.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M525.16,871.2l36.81-.73c6.09-100.53,11.17-238,37.29-342.14,27.77,67.28,19.1,252.61,48.09,342.87l34.19-.73c-8.16-101.52-8.75-239-15.38-366.26-1.48-21.17-3.35-40.86-5.8-57.9l-130-2.69C534.11,543.31,505.85,760.73,525.16,871.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M611.8,524.58c-1.91,2.4-15.55,3.65-11.34,8.88C625.18,589.21,619.78,768.35,642,850.1,623.87,746.42,657.12,623.05,611.8,524.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M596.53,530.68c34.43,11.47,11.75-49.79,12.05-68.36-10.32,1.4,3.12,26,1.28,35.22C611.7,521.39,614,524.8,596.53,530.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M596.53,530.68a117.85,117.85,0,0,1-1.3,13c1.06-3.11,3-17.79,5.23-10.25C600.28,469.42,589.76,453.51,596.53,530.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M528.47,507.26c47.73,13.13,47-50.64,33.15-46.75C572.61,508.66,554.61,495.71,528.47,507.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M645.24,481.57c-2.13,14.31,16.06,35.42,20.92,22.65-19.07-.2-19.16-30.43-13.6-42.41C644.84,455.54,645.39,473.24,645.24,481.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 640.82,
    y: 859.2,
    width: 45.05,
    height: 20.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 521.25,
    y: 858.34,
    width: 45.05,
    height: 20.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M597.52,534.55c.38-1.4.74-2.76,1.14-4.13C596.74,530.78,597.79,533.09,597.52,534.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M517.68,280c10,63,11.45,129.88,6.2,193.56,11.89,5.64,27.48-2.35,38.09,3.59,81.8,39.33,110.13,20,104.55-34.94.69-35.16-4-73.51-.65-107.44,4.32-51.47,34.6-94-10.32-128.82-10.68-7.68-61.6-35.47-69.31-23.39C532.16,205.4,501.91,209.13,517.68,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M666,133.17c-.47-10.1,7.66-22.42,15.37-16.88C695.65,129.23,667.15,159.75,666,133.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M669.82,126.11c1.74-6.78,11.12-11.67,12-1.8-2.09-5.34-5.82-1.21-8.07,1.6,4.64,1.88,2.06,9.23-2.81,8.72C672.33,131,674.14,127.87,669.82,126.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M672.33,62.28c17.29,12.94,9,46.87-1.39,61.2C673.86,69.24,641.17,83.09,672.33,62.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M591.86,128.66c5.45,39.15-21.67,77.36,39.32,83.79,19.26-2.42.19-28.11,6-42.5C637,171.41,587.1,118.91,591.86,128.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M591.86,128.66c1.59,8,2.44,7.58,1.89,16.13,8.62,47,50,50.83,43.45,25.16C637.11,171.43,589.19,120.91,591.86,128.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M674.21,99c-6.31-73.7-99.81-74.45-81,46.88,1.44,22.53,35.82,38.29,50.25,35.24C676.44,167.52,673.4,127.46,674.21,99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M625.41,110.55c-4.64-9.75-16.89,3.14-15.91,8.9C612.88,114.07,632.6,124,625.41,110.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M627,119.91c-3.54.54-19.37,2.37-16.17-2C614.93,110.37,627.81,109.37,627,119.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M625.64,115.34c2.06,7.53-13.57,6.92-14.78,2.57C613.63,113.36,623.29,108,625.64,115.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M616.73,117.46a1,1,0,1,1-2,0A1,1,0,1,1,616.73,117.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M667.13,109.93c-4.38-9.93-15.68,3.6-14.61,8.9C655.75,113.61,673.92,123.06,667.13,109.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M668.62,119.29c-5.09,1.25-11.19.76-16.1-.23C655.81,110.93,669.21,107.31,668.62,119.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M667.34,114.72c2.14,7.32-12.51,7-13.57,2.57C656.22,112.76,665.28,107.44,667.34,114.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M659.16,116.84c0,1.44-1.8,1.44-1.79,0S659.18,115.39,659.16,116.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M645.65,125.31c-1.48,7,4.54,17.94-7.23,17.95C654.13,146.71,647.53,134.38,645.65,125.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M604.7,108.31c7.39-4.06,19.88,3.37,25.53-1.5C633.44,92.49,600.41,98.15,604.7,108.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M674.36,108.5c-6.49-3.83-17.46,3-22.29-1.52C649.21,93.57,678.05,99,674.36,108.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M622.26,146c10.86,15.59,24.83,17.6,32,3.06C645.7,151,635.29,151.18,622.26,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M622.26,146c9.08,13.44,25.31,19.31,25.9,4A55.35,55.35,0,0,1,622.26,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M582.91,71.26c-6,18.12,6.2,76.29,14.31,45.21C595.44,97.85,608.69,98.39,612,83.62c7.16-15.23,20.31-1.73,32.21-1.68a149.86,149.86,0,0,0,27.6,1.38c4-1.21,24.48-7.17,24-34.25-22.27,21.06-8.49-4-11.16-16.88-1.94,15.05-24,9.05-32.89,7.81-68.33-9.47-47.06,19.89-76.43,16.17,8.16,6.42,5.73,4.76-1.09,9.94C578.16,64.9,584.33,66.94,582.91,71.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M582.91,71.26c-5.95,18.09,6.19,76.32,14.31,45.21C595.43,97.87,608.7,98.38,612,83.62c7.15-15.21,20.31-1.74,32.21-1.68-11.44-11.22-22.79-17.41-37.57-11.68,7.69-12.67-.43-8.38-7.91-1.77C604.19,58.8,563,48,582,62.25,566.18,66.7,584.76,63.39,582.91,71.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M595.7,130.23c.5-10.79-8.19-23.95-16.41-18C564,126,594.43,158.62,595.7,130.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M591.58,122.69c-1.86-7.24-11.88-12.46-12.82-1.93,2.24-5.7,6.21-1.29,8.62,1.71-5,2-2.2,9.86,3,9.32C588.9,127.89,587,124.57,591.58,122.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M526.13,370.45c-.38,19.93-2.16,28.18,20.46,26.75,35,5.13,129.2,42.45,118.3-18C619.72,399.3,572.16,369.66,526.13,370.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M523.38,324.16c-6.92,39.91,42.54,27.44,69.93,38.58,30.54,3.53,80.84,14.77,72.55-28C619.56,350.67,570.4,327.32,523.38,324.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M517.68,280c10,63,11.45,129.88,6.2,193.56,11.89,5.64,27.48-2.35,38.09,3.59,78.06,37.66,109.29,21.73,104.52-29.58,9.9-56.84-42.28,13.8-81.55-21.09-57-48.36-19-112.9-34.22-175.47-5.44-16.3-30.44.62-35.15-18.61C513.63,241.81,513.3,255.45,517.68,280Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M524.29,467.64l14-5.62c8.65,16.24,34.93,31.55,19,39.72C531.52,517.53,525.39,486.2,524.29,467.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M476,358.4c52.64,4.25,41.56,78.74,67.18,111l-15.33,11C508,452.55,443.3,389.19,476,358.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M476.71,305.6c24.29-57.52,15.46-90.47,58.48-19-5.52,6.24-32.65,93.77-40.59,99.66C446.45,421.75,471.3,324.81,476.71,305.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M555.75,475.45c4.45,5.43,30,11.68,10.93,16-13.16-1.77-21-12.65-28-21.27C543,472,551.53,472.62,555.75,475.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M546.77,526.51c21.5-38.07-46.54-56.15-48.62-14.39,15.11,7.74,6.19-26.66,29.5-17.08C555.6,501.15,534.39,520.78,546.77,526.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M440,619.69c125.52,78.09,105.6-1.81,130.61-95.53C460.36,480.06,455.62,526.29,440,619.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M550.08,539.49c50.11-61.79,22.32,96.52,11,112.63,0,0-26,4.93-31.19-2.59C518.56,633.16,542,554.93,550.08,539.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M508.93,585c15,8.27,11.64-45.42,36.53-66.67C526.94,504,510.6,564.82,508.93,585Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M468.2,572c14.93,8.28,12-45.07,34.62-64.14C476.75,505.33,472.61,550.54,468.2,572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M555,551.44c-3.34,10.89,14.45,16.08,17.47,5.08,2.06-7,8-20.39-3.34-22.63C558.81,530.68,557.07,544.78,555,551.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M558.83,544.81c49-93.42,104.52-243.14,78.1-353.62C699,196.07,599.86,560.82,558.83,544.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M507.77,233.05c21.17-45.65,60.51-32.4,48.79,17.1-3.93,27.35-19,58.58-28.78,84.53C440.62,322.34,484.06,289.41,507.77,233.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M729.48,393.27c-11,17.13-31.79,9-40.72-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M562.42,389.6c-1.36,15.31,215.17.66,220.55,5.58a5.58,5.58,0,0,0,5.56-5.58c.57-4.18-5.84-6.17-5.64-5.58C772.82,389,561.69,374.17,562.42,389.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M664.47,284c2.76,4.42-29.13,108.93-14,105.53C789,378.21,786.08,439.13,812.44,284,818.92,272,660.29,273.51,664.47,284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M671.2,284c-36.49,156-19.33,93.43,112,105.54,8.93,7.06,36.59-117,23.89-112.17C801.36,281.11,669,269.14,671.2,284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M726,318.54c-1.82,12.41,21.05,9.94,22.1,0C750,306.13,727.05,308.59,726,318.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M718.83,387.53c-2.83-6-.1-17.8,8.41-8.26C743.21,399.16,694.38,412.73,718.83,387.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M729.36,386.12c-2.4-6.86-.1-20.4,7.13-9.46C750.41,397.76,708.83,416.29,729.36,386.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M737.54,386.73c-2.41-6.86-.11-20.4,7.12-9.46C758.58,398.36,717,416.9,737.54,386.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M745.71,386.71c-2.41-6.86-.11-20.41,7.12-9.46C766.75,398.34,725.17,416.88,745.71,386.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M254.66,399c-4.77,20.42-16.74,45.71,12.9,48.18C267.56,432.7,263.64,395.68,254.66,399Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M274.64,462.24c-4.8-17.92-11.35-44.53-20-11.33C252.55,463.79,290.31,489.25,274.64,462.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M199.05,931.82c-15.22,8.7-74.9,2.11-80.88-1.3-1.81-4.47,1.8-20.43-.87-20.87l33.92-10c4.86,9.38,6.61-1,13,7C168.9,919.34,211.15,913.72,199.05,931.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M201.58,925.47c-9.34,15.18-87.91,9.89-83.82-2.65C126.13,929.65,190,927.29,201.58,925.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M163.06,896.12c-2.87-11.31-22.21-5.91-20.26,5.47-5.28,17.87,21.08,8.84,30.16,11.54A59.76,59.76,0,0,1,163.06,896.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M240.5,565.71c-16.6,39.1-56.68,276.15-86,335.13-22.07,3.7-43.48,27-37.18-12.65,21.94-173,62.76-270.51,30.06-421.84,3.75-27.59,7.22-36.26,21-66.89C266,461.57,284,444.26,240.5,565.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M245.2,437.13c0,24.54-2.31,49.35-6.51,69.31-4.28,2.82-20.72.33-8.66-2.64C248.05,500.35,232.45,445.57,245.2,437.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M224.85,555.28c-.55-18.4,5.21-83.18-3.52-100.07C251.23,439.92,221,550.68,224.85,555.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M236.35,935.78c-17.44,8.7-85.84,2.11-92.7-1.3-2.07-4.5,2-20.46-1-20.87l38.87-10c5.57,9.38,7.58-1,14.95,7C201.34,923.33,249.52,917.11,236.35,935.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M239.24,929.43c-11.76,15.18-99.36,10.12-96.06-2.65C152.93,933.56,225,931.33,239.24,929.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M223.77,548.88c-2.72,38.43-36.56,278.49-40.23,347.76C183.76,910,164.88,907,157,914.48c-4.56,3-11.39,9.47-16.1,6.19-10.61-33.28,5.87-123,5.43-140.08,4.39-93.05,7.41-224.81-23.25-305.33.87-27.83,3.41-36.81,13.91-68.7C271.66,419.66,225.19,436.81,223.77,548.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M163.53,656.43c2.83,86.07-15.27,172.32-6.53,258-8.73-6.73-4.53-49.27-5.65-65.29,20-132.94-2.36-277.79,6.93-405C153.26,514.87,164.6,585.51,163.53,656.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M195.1,900.08c-9.14-16.43-29.75,1.22-22.8,16l34.15,1A58.38,58.38,0,0,1,195.1,900.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M162.55,497.46c-22.59-9.71,42.22,13.94,31.3-50.91,4.58-.81,4,1.48,4,5.43C201.36,476.26,189.74,501.56,162.55,497.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M255.27,285.24c41.17-5.36,13.71-49.71,6.9-75.34-1.93-22.4-36.1-35.84-50.35-37.2-27.76,14.41-22.67,40.14-18.24,63.3C203.42,275.08,208,309.3,255.27,285.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M269.11,271.62c-15.33,34.64.63,178.47-9.66,189.06-45.67,11.32-101,2.6-140.61-23.09,54-71.62-68.71-271.92,44.84-284.07C244.58,157.74,259.67,196.54,269.11,271.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M263.9,294c-18.46,82.16,45.19,197-68.46,170.29-29.39-3.11-52.84-12.36-76.6-26.66,48.14-64.92-47.12-242.87,20.3-264.47-6.29,12.22,39.41,28.68,40.89,42.67C183.52,280.42,182.44,324.2,263.9,294Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M219.94,160.21l-29.35,28C224.89,227.76,273,197.6,219.94,160.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M260.7,38.94c-27.44-12.52,1.17,13.4-1.94,37.47C264.74,67,272.29,44.73,260.7,38.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M189.37,111.1c-11.6-4.9-11.2,11.46-8.47,18.46C190.88,139.08,189.42,115.93,189.37,111.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M243,118.35c-1.41,20-14.56,40.85-8.91,60.05,2.06,4,8,15.43,1.86,18.28-25.92,12-59.4-37-82.45-42.63,25.72.22,37.48-24.42,31.14-48.63C194.6,107.84,233.71,117,243,118.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M242.73,118c-.62,79.06-62.11,3.08-58.35-17.74L230,113.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M261.82,76.44c7.54-83.19-114.22-58.4-82.43,9.4C189.21,165.77,286.09,169.67,261.82,76.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M224.53,94c-6.58-.88-15.27-3.12-20.16-3.24C210.11,85.46,222.92,84.64,224.53,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M224.08,93.83a62.14,62.14,0,0,1-19.71-3.08C210.8,88.16,220.13,86.78,224.08,93.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M219.46,93.36c-3.3.83-17.86-1.76-10.15-4.14C213.57,88.32,220.1,87.47,219.46,93.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M212.24,91.14c-.19.9-1.75.55-1.54-.34S212.46,90.25,212.24,91.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M262.43,84.71c-5.19,2.28-12.59,4.36-16.16,6.5C247.65,84.08,257.15,77.31,262.43,84.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M262,84.77a45.29,45.29,0,0,1-15.76,6.44C249.55,86,256,80.43,262,84.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M258.46,86.51c-2.45,1.77-9.89,6-10.62,2.56C250.59,85.68,256.05,80.52,258.46,86.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M252.16,87.91a.67.67,0,1,1-1.28.41A.67.67,0,1,1,252.16,87.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M246.12,108.79c-4.83-5.23-4.37-9.45-6.22-15.61-1.76,9.28,6.42,16.47-5.68,19.92C239.5,114.16,244.77,112.75,246.12,108.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M223.16,77.76c.62-.71-22.32-2.36-24.95,5.33C203.11,79.75,227.91,86.94,223.16,77.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M242.9,75.7c1.26-1,18.91-5.44,22.63,1.4C260.69,74.57,240.37,85.47,242.9,75.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M226.43,119.09c8,3.33,18.59,4,25.12-2.57C247,125.53,233.24,125,226.43,119.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M238.14,130.49a29.78,29.78,0,0,0,7.83.9C244.27,128.37,240.45,128.46,238.14,130.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M201.51,33.43C174.88,38,165.07,69.09,170.87,93.77c15.07-10.52,12.1,10,18.35,14.26,5.36-15.35-5.06-32.36,7.64-45.07C198.23,54.47,192,38.55,201.51,33.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M182.62,92.3c-27.27-11.58-6.58,39.5,9.11,24.08C190.38,105.64,187.61,96.41,182.62,92.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M186.2,106.81c-7.12,3.52-4.63-6.09-6.07-9.81-3.48-6.16-9.56-2.15-7.16,3.49.18-3.26,3.22-3.41,5.11-1.19C167.28,110,191.24,115.2,186.2,106.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M255.17,39.88c-5.27,13.13-22.68,17-31.68,27.71,7.42-23.71-14-4.7-19,8-3.73-5.36-1-14.19,1.48-19.58-6,1.27-10.95,10.54-13.22,15.54-4.72,12.61,2.22,34.69-10,10.77-3.94-16.87-6,6.41-9.84-1.68-2.17,2.27-6.51,10.57-6.58,10.56-1.48.1.62-19.2-4.66-7.23,1.68-13.28-7.28-8.59,2.64-20.38-22.24,10.12,11.13-41.18,26.59-43.73C211.35,7.28,255.27,8.42,255.17,39.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M178,41l0,0C178.12,41,178.18,40.88,178,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M255.17,39.88c-5.27,13.13-22.68,17-31.68,27.71,7.42-23.71-14-4.7-19,8-3.73-5.36-1-14.19,1.48-19.58-6,1.27-10.95,10.54-13.22,15.54-4.72,12.61,2.22,34.69-10,10.77-3.94-16.87-6,6.41-9.84-1.68-2.17,2.27-6.51,10.57-6.58,10.56-1.48.1.62-19.2-4.66-7.23,1.68-13.28-7.28-8.59,2.64-20.38-17,13-1.2-20.22,5.26-26.78a75.89,75.89,0,0,0-.94,9.9c1.58-3.19,6.26-4.46,9.37-5.62-4.21,6.1-6.38,23.23,2.91,11.32.28,4.6.7,11.58,4.37,14.8-.15-15.82,16.47-25.67,28-33.11-2.36,2.71-8.13,17.35-.88,10.74-1.29,16.09,12.08,1.55,16.2-4.82C227.3,65.07,258.48,21.67,255.17,39.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M209.43,106c-7.4,1.81-16.63-11.34-15.29-18.35C202,81,239.33,74.66,231,93.89,229.92,103.49,218.33,106.42,209.43,106ZM196.18,89c.2,10,12.17,17.84,22.83,13.89C249.18,85,209.9,77.86,196.18,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M252.06,101.66c-6.54,1.77-14.41-12.36-13.2-18.52,5.32-6.08,32.25-10.5,32.13.83C271.57,95,263.61,103.18,252.06,101.66ZM240.6,84.47c.16,8.49,9.19,18.32,19.55,14.16C284.83,82.76,254.12,72.72,240.6,84.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M230.3,86.09c-4.85-4.81,14-6.85,9.73-1.21A10.93,10.93,0,0,0,230.3,86.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M102.52,248c6.47-5.51,15.85-3.23,23.5-3.69l2-79.57C100.6,186.24,95.86,214.81,102.52,248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M95.06,211.74c-9.6-11.63-34.39,9-32.18,21.74-.25,6.25-.85,22.54-6.76,25.22,13.72,1.07,8.72-19,13.92-27,8.42-14.82,27.61-16,26.28,5.15C98,231.58,98.46,217.13,95.06,211.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M167.85,389.84C53.25,643.59-39.56,272.27,107,216.25l9-12.34C117.3,214.34,128.09,226,132.71,236c15.55,26.92,29.75,52.24,22.27,84.69C151.92,345.36,169.16,365.83,167.85,389.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M167.85,389.84C84.47,574.93,13.69,430.17,35.22,306.7,55.6,270,69.4,201.43,76.53,284.35c7.34,21.5,9.75,43.58,15,65,27.45,6.15,50.3-3.32,63.49-28.72C151.91,345.33,169.17,365.9,167.85,389.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M167.85,389.84c-14.47,28.61-36.77,75.81-68.23,87.26-22.25,3-38.11-2.44-34.6-24.73-1.8-26.58,14-81,47.71-70.76C133.75,384.49,174.19,352.19,167.85,389.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M177.8,176.78C197,221,156.3,342.06,142.23,375.25c39.77,29.66,118.63-259.91.09-218.95C152.12,157.13,173.42,167.79,177.8,176.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M306.94,297c-1.05,6.3-10.21,1.95-14.4,2.15C291.51,280.9,305.91,277.05,306.94,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M294.74,253.61c-4.39,3.58-18.81,151.51-30.13,148.72-2.19-3.11-99.53-11.57-94.47-20.71,4.39-3.59,18.8-151.52,30.13-148.72C202.46,236,299.8,244.46,294.74,253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M294.74,253.61c-4.39,3.58-18.81,151.51-30.13,148.72-2.33-3.14-95.15-10.78-90.36-20,4.38-3.58,18.8-151.52,30.12-148.72C206.7,236.75,299.52,244.38,294.74,253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M263.11,292.59c-.26,8.63-34.61-3.36-38.49-2.34-6.44-1.14-3.17-19.69,3.23-18.61C239.92,276.69,273.05,269.59,263.11,292.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M306.81,265c-4.78,3.22-32.86,149-44,145.22-1.89-3.3-98-20.9-92.09-29.52,4.78-3.22,32.87-149,44-145.22C216.61,238.78,312.72,256.38,306.81,265Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M306.81,265c-4.78,3.22-32.86,149-44,145.22-2-3.35-93.71-19.7-88.07-28.43,4.78-3.22,32.87-149,44-145.22C220.76,239.93,312.45,256.28,306.81,265Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M271.65,300.84c-1.06,8.57-34.13-6.61-38.1-6-6.3-1.74-1.29-19.9,5-18.23C250.07,282.82,283.72,278.88,271.65,300.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M174.86,313.37c-.86,16.93-5.22,50-25.73,53.43-45.3-11.41-31.77-91.07-36.17-138.1C179.54,249.63,177.19,242.57,174.86,313.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M261.42,293.8c-27.49,27.17-68.57,10.89-102.67,22.3-12.14,4.06-37.39-21.34-40.56-7.17-2,40.22,11.7,82.66,65.23,56.09,21.54-10,59.08-25.6,78-38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M161.89,265.88c1,.46,0-1.21,0-1.76A10.35,10.35,0,0,1,161.89,265.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M174.86,313.37c-9.13,3.71-16.94,9.38-25.92,16.33,11-14.47,20.78-24.63,15.59-43.6,1.24-12-8.7-24.54,9.82-17.27C174.86,283.89,175.29,302.08,174.86,313.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M299.59,279.43c4.27-12.8-7.16-6.36-13.23-2.84-13.08,7.59-29.06,7.09-28.82,24.34l-8.07,6c-1.59,13.22,8.22,23.37,30.28,23.37,8,0,14.59-35.58,5.79-39.92C291.78,285.93,298.32,283.24,299.59,279.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M306.57,296c-1.13,3-4.42,6.41-2.25,10.38-3,20.69-20.76,30.44-41,21.42L276.78,288C283.75,292,304.27,283.91,306.57,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M306.57,296c-1.12,3-4.43,6.41-2.25,10.38-2.77,8.36-4.79,18.6-15.13,23.38.35-10.5,11.69-19.93,7-30.47C299.86,293.14,298.32,282.11,306.57,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M179.67,276.8c-.72,27.86-46.86,16-66.39,13.23-2.84-35.62-7-74.15,3.92-108.54,19-51.38,68-6.41,63,31.81C181.35,233,182.38,256.18,179.67,276.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M179.67,276.8c5.22,24.42-71.26,24.9-67.44,2.32C134.2,283,158.62,283,179.67,276.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted3);
export default __webpack_public_path__ + "static/media/get_started_3.04da59c05787c752ca581ef63d01a9e9.svg";
export { ForwardRef as ReactComponent };